const { client, loadToken } = require('./client');
export { loadToken };

export async function getUser() {
    var { data } = await client.get(`/user`);
    return data;
}

export async function updateSystemMode(body) {
    var { data } = await client.put(`/user/system-mode`, body);
    return data;
}

export async function getSubscriptionsForUser(){
    var { data } = await client.get('/email/subscription');
    return data;
}

export async function processSubscription(body){
    var { data } = await client.post('/email/subscription', body);
    return data;
}

export async function updateSubscriptionStatus(body){
    var { data } = await client.put('/email/subscription', body);
    return data;
}

const all = {
    loadToken, getUser, updateSystemMode, getSubscriptionsForUser, processSubscription, updateSubscriptionStatus
};

export default all;